export default __webpack_public_path__ + "2676432fe5dc9ac6311511f9ebf3170f.svg";